import { render } from "./Faculties.vue?vue&type=template&id=3fdd612d&scoped=true"
import script from "./Faculties.vue?vue&type=script&lang=js"
export * from "./Faculties.vue?vue&type=script&lang=js"

import "./Faculties.vue?vue&type=style&index=0&id=3fdd612d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fdd612d"

export default script